import { Controller } from 'stimulus';

export default class extends Controller {
  #menuGroupSyncer;
  static values = { controlActivatesGroup: Boolean, selected: String };
  static targets = ['groupStatus', 'control', 'group'];

  connect() {
    const criteria = { attributes: true, attributeFilter: ['class'], subtree: true };
    this.#menuGroupSyncer = this.#syncGroupOnControlStatusChange();
    this.#menuGroupSyncer.observe(this.element, criteria);
  }

  disconnect() {
    this.#menuGroupSyncer.disconnect();
  }

  selectedValueChanged() {
    this.#updateMenuGroupState();
  }

  #syncGroupOnControlStatusChange() {
    return new MutationObserver((mutations, _) => {
      const mutationInControl = (mutation) => this.controlTargets.includes(mutation.target);
      const menuControlChanged = mutations.some(mutationInControl);

      menuControlChanged && this.#updateMenuGroupState();
    });
  }

  #updateMenuGroupState() {
    const controlIsActive = (control) => control.classList.contains('active');
    const activeControl = this.controlTargets.find(controlIsActive);

    if (activeControl) {
      this.#renderStatus(activeControl.innerHTML, activeControl.textContent.trim());
      this.controlActivatesGroupValue && this.groupTarget.classList.add('active');
    } else if (this.selectedValue) {
      this.#renderStatus(this.selectedValue, this.selectedValue);
      this.controlActivatesGroupValue && this.groupTarget.classList.remove('active');
    } else {
      this.controlActivatesGroupValue && this.groupTarget.classList.remove('active');
    }
  }

  #renderStatus(html, text) {
    const statusElement = this.groupStatusTarget;
    const statusIsInput = statusElement instanceof HTMLInputElement;
    const prop = statusIsInput ? 'value' : 'innerHTML';
    const value = statusIsInput ? text : html;

    statusElement[prop] = value;
  }
}
